import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {

  transform(sizeInBytes?: number | string | null): string {
    const parsedSize = Number(sizeInBytes);

    if (!Number.isFinite(parsedSize)) {
      return '0.00 KB';
    }

    const kilobytes = parsedSize / 1024;

    if (kilobytes > 1000) {
      return `${(parsedSize / (1024 * 1024)).toFixed(2)} MB`;
    }

    return `${kilobytes.toFixed(2)} KB`;
  }
}
